import "./tabs.css";
import { Tab, Tabs } from './tabs';
import { attachPropertiesToComponent } from '../../utils/attach-properties-to-component';
export default attachPropertiesToComponent(Tabs, {
  Tab
});